import { useIntl } from 'react-intl';

import { createGroupLabel, useGroups } from '@/modules/groups';

import type { ViewFilter } from '../../types';
import { Option, SecretsViewSelect } from '../SecretsViewSelect';

export interface SecretsViewGroupSelectProps {
    viewFilter: ViewFilter | null;
    onChange: (viewFilter: ViewFilter | null) => void;
}

export const SecretsViewGroupSelect = ({ viewFilter, onChange }: SecretsViewGroupSelectProps) => {
    const { dataWithLocalizedAllUsersGroup, api, handleSearch, handleLoadMore } = useGroups();

    const intl = useIntl();

    const viewedAsGroup = viewFilter?.type === 'group' ? viewFilter : null;
    const groups =
        viewedAsGroup && !dataWithLocalizedAllUsersGroup.some(({ id }) => id === viewedAsGroup.id)
            ? [viewedAsGroup, ...dataWithLocalizedAllUsersGroup]
            : dataWithLocalizedAllUsersGroup;

    return (
        <SecretsViewSelect
            placeholder={intl.formatMessage({
                id: 'secrets.view.modal.group.placeholder',
            })}
            onChange={value => {
                const option = groups.find(({ id }) => id === value);

                if (!option) return;

                onChange({
                    id: option.id,
                    email: option.email ?? '',
                    name: option.name ?? '',
                    type: 'group',
                });

                handleSearch('');
            }}
            options={groups.map(group => ({
                key: group.id,
                value: group.id,
                title: group.email,
                label: <Option icon='group'>{createGroupLabel(group)}</Option>,
            }))}
            onSearch={handleSearch}
            hasMoreOptions={Boolean(api.nextPageToken)}
            loadingMoreOptions={api.inProgressNext}
            onMoreOptions={handleLoadMore}
            defaultValue={viewFilter?.type === 'group' ? viewFilter?.id : undefined}
        />
    );
};
